class BmPickupAvailability extends HTMLElement {
  constructor() {
    super();

    // WL: prefijo en vez de ID exacto — en la vista rápida el tema agrega "-modal" a los IDs
    this.widgetContainer = this.querySelector('[id^="PickupAvailabilityWidget"]');
    this.widgetSidebar = this.querySelector('[id^="PickupAvailabilitySidebar"]');
    this.triggerOpen = this.querySelector('button.pickup-availability-widget__check');
    this.triggerClose = this.querySelector('button.sidebar__close');
    this.variants = JSON.parse(this.querySelector('script[data-variant-info]').textContent);
    this.variantIds = this.variants.map(v => v.id);
    this.sidebarContent = this.querySelector('[id^="PickupAvailabilitySidebar"] .store-availabilities-list-wrapper');
    this.inputs = this.querySelectorAll('input');
    this.availableText = this.dataset.availableText;
    this.notAvailableText = this.dataset.notAvailableText;
    this.noStoreAvailableText = this.dataset.noStoreAvailableText;
    this.regionFilter = this.querySelector('select[name="region_id"]');
    this.selectedRegion = '';
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Open sidebar
    if (this.triggerOpen) {
      this.triggerOpen.addEventListener('click', () => {
        this.widgetSidebar.classList.add('bm-pickup-sidebar-open');
        document.body.classList.add('bm-pickup-sidebar-open');
      });
    }

    // Close sidebar
    if (this.triggerClose) {
      this.triggerClose.addEventListener('click', () => {
        this.widgetSidebar.classList.remove('bm-pickup-sidebar-open');
        document.body.classList.remove('bm-pickup-sidebar-open');
      });
    }

    // Region change
    this.sortRegionOptions();
    if (this.regionFilter) {
      this.regionFilter.addEventListener('change', e => {
        this.regionFilterHandler(e);
      });
    }

    // Variant input change
    this.inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        this.updateOriginalOption(e.target);
      });
    });

    // Document click to close
    document.addEventListener('click', e => {
      this.handleDocumentClick(e)
    });

    // original variant change event listener
    this.originalVariantChnageListener();
  }

  handleDocumentClick(e) {
    if (!this.widgetSidebar) return;
    const isInsideSidebar = e.target.closest('[id^="PickupAvailabilitySidebar"]');
    const isToggleBtn = e.target.closest('button.pickup-availability-widget__check');
    const isOrigianlVariant = e.target.closest('fieldset.variant-input-wrap');

    if (!isToggleBtn && !isInsideSidebar && !isOrigianlVariant) {
      this.widgetSidebar.classList.remove('bm-pickup-sidebar-open');
      document.body.classList.remove('bm-pickup-sidebar-open');
    }
  }

  sortRegionOptions() {
    if (!this.regionFilter) return;

    const options = Array.from(this.regionFilter.options);
    const firstOption = options.find(opt => opt.value === '');
    const sorted = options.filter(opt => opt.value !== '').sort((a, b) => a.text.localeCompare(b.text));

    this.regionFilter.innerHTML = '';
    if (firstOption) this.regionFilter.appendChild(firstOption);
    sorted.forEach(opt => this.regionFilter.appendChild(opt));

    // check & update selected value based on previous selection
    const values = sorted.map(opt => opt.value);
    this.regionFilter.value = values.includes(this.selectedRegion) ? this.selectedRegion : '';
  }

  async variantChangeHandler(variantId) {
    this.classList.add('bm-loading');

    try {
      const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}/?section_id=bm-pickup-availability-loader`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // update available unavailable text
      var availableText = doc.querySelectorAll('[data-available-text]');
      var unavailableText = doc.querySelectorAll('[data-not-available-text]');
      if (availableText.length) {
        availableText.forEach(text => {
          text.innerHTML = this.availableText;
        })
      }
      if (unavailableText.length) {
        unavailableText.forEach(text => {
          text.innerHTML = this.notAvailableText;
        })
      }

      // update no store available text
      doc.querySelector('.store-availabilities-list__match').textContent = this.noStoreAvailableText;
      if (!doc.querySelector('.store-availabilities-list')) doc.querySelector('.store-availabilities-list__match').classList.remove('hidden');

      const sidebarContent = doc.querySelector('#generatePickupAvailabilitySidebar .store-availabilities-list-wrapper');
      if (sidebarContent && this.sidebarContent) this.sidebarContent.innerHTML = sidebarContent.innerHTML;
    } catch (error) {
      console.log('Pickup availability fetch error:', error);
    } finally {
      this.classList.remove('bm-loading');

      // re-init
      this.regionFilter = this.querySelector('select[name="region_id"]');
      if (!this.regionFilter) return;
      this.sortRegionOptions();
      this.regionFilter.addEventListener('change', e => {
        this.regionFilterHandler(e);
      });
      this.regionFilter.dispatchEvent(new CustomEvent('change', {
        detail: { selectedRegion: this.selectedRegion },
        bubbles: true
      }));
    }
  }

  regionFilterHandler(e) {
    this.selectedRegion = e.detail?.selectedRegion || e.target.value;
    const allItems = Array.from(this.querySelectorAll('.store-availability-list__item'));
    const matchNotice = this.querySelector('.store-availabilities-list__match');
    
    // Show all items if no region is selected
    if (this.regionFilter.value === '') {
      allItems.forEach(item => item.classList.remove('hidden'));
      if (matchNotice) matchNotice.classList.add('hidden');
      return;
    }

    // Otherwise, filter by selected region
    allItems.forEach(item => {
      const region = item.getAttribute('data-region') || '';
      const isMatch = this.selectedRegion === '' || region.includes(this.selectedRegion);
      item.classList.toggle('hidden', !isMatch);
    });

    const allHidden = allItems.every(item => item.classList.contains('hidden'));
    if (matchNotice) matchNotice.classList.toggle('hidden', !allHidden);
  }

  originalVariantChnageListener() {
    document.addEventListener('variant:change', (e) => {
      // WL: el evento es global; ignorar variantes de otros productos (ej. vista rápida sobre la ficha)
      const variant = e.detail && e.detail.variant;
      if (!variant || !this.variantIds.includes(variant.id)) return;
      if (variant.id) {
        this.updateModalOption(e.detail.variant);
        this.variantChangeHandler(e.detail.variant.id);
      }
    });
  }

  updateModalOption(variant) {
    variant.options.forEach((option, index) => {
      const input = this.querySelector(`[data-option-index="${index}"] input[value="${option}"]`);
      if (input) {
        input.checked = true;
      }
    })
  }

  updateOriginalOption(el) {
    const optionIndex = el.dataset.optionIndex;
    const optionValue = el.value;
    // WL: buscar la talla en el producto propio, no la primera de la página
    const root = this.closest('.modal--quick-shop') || this.closest('.shopify-section') || document;
    const originalOption = root.querySelector(`input[data-index="option${optionIndex}"][value="${optionValue}"]`);
    if (originalOption) {
      originalOption.click();
    }
  }
}

customElements.define('bm-pickup-availability', BmPickupAvailability);
